import {useABTestStore} from '../store/ab-test.store';

export const useABTest = () => {
    const {getVariation, getVariationWithoutTracking} = useABTestStore();

    return {
        getVariation,
        getVariationWithoutTracking,
    };
};
